export default "__VITE_ASSET__D4r3cuM1__"